import React, {Component} from 'react';
import * as api from '../../api/changelog-api';

class Logo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      backendVersion: '',
    };
  }

  componentDidMount() {
    this.getBackendVersion().then((result) => this.setState({
      backendVersion: result,
    })).catch((err) => this.handleError(err));
  }

  getBackendVersion() {
    return api.getCurrentVersion();
  }

  render() {
    const style = {
      'padding': '10px 12px 0 15px',
    };
    return (
      <div className="page-logo" style={style}>
        <a href='/'>
          <img src="/assets/images/hafele_icon.png" className="logo-default" alt=""/>
        </a>
        <div style={{marginTop: '8px', marginBottom: '20px'}}>
          <span style={{color: '#CCC'}}>Credential Service v{this.state.backendVersion}</span>
        </div>
      </div>
    );
  }
}

Logo.propTypes = {};
Logo.defaultProps = {};

export default Logo;
